import { render, staticRenderFns } from "./IdentityForm.vue?vue&type=template&id=070d4dd1&scoped=true"
import script from "./IdentityForm.vue?vue&type=script&lang=js"
export * from "./IdentityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d4dd1",
  null
  
)

export default component.exports